import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import LinkButton from 'flarum/common/components/LinkButton';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
let privateUnreadCount = 0;
let refreshing = false;
async function refreshPrivateUnreadCount() {
  /* TEMPORAIRE — compteur MP désactivé : diagnostic boucle mobile */
  return;
}

/* VAL — rafraîchissement compteur MP après lecture */
let privateRefreshTimer = null;
function schedulePrivateUnreadRefresh() {
  clearTimeout(privateRefreshTimer);
  privateRefreshTimer = window.setTimeout(refreshPrivateUnreadCount, 700);
}
app.initializers.add('val-ui-private-messages-access', () => {
  /* VAL — hooks lecture MP */
  extend(DiscussionPage.prototype, 'positionChanged', schedulePrivateUnreadRefresh);
  extend(DiscussionListItem.prototype, 'markAsRead', schedulePrivateUnreadRefresh);
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (!app.session?.user) return;
    items.add('val-private-messages', LinkButton.component({
      href: app.route('byobuPrivate'),
      icon: 'far fa-envelope',
      className: 'Button Button--flat ValPrivateMessagesButton',
      title: 'Messages privés',
      'aria-label': 'Messages privés'
    }, [m('span.ValPrivateMessagesLabel', 'Messages privés'), privateUnreadCount > 0 ? m('span.Bubble.ValPrivateMessagesBubble', {
      'data-digits': String(privateUnreadCount).length
    }, privateUnreadCount) : null]), 11);
  });
  app.beforeMount(() => {
    if (!app.session?.user) return;
    refreshPrivateUnreadCount();
  });
});